import {
  DeliveryStatusValue,
  IDriver,
  IDriverActiveOrder,
  IDriverDelivery,
  IRegisterDriver,
  IUpdateDriver,
} from "../models/IDriver";
import { configWithUserToken } from "./config";
import { restaurantQuery } from "../utils/activeRestaurant";

export const getDriversByRestaurant = (restaurantId: string) =>
  configWithUserToken.get<IDriver[]>(`Driver/restourant/${restaurantId}`);

export const getMyRestaurantDrivers = () =>
  // Çok restoranlı hesapta aktif restoranın kuryeleri (?restaurantId=); tek restoranlıda eskisi gibi.
  configWithUserToken.get<IDriver[]>(`Driver/my-restaurant/drivers${restaurantQuery()}`);

export const getDriverById = (driverId: string) =>
  configWithUserToken.get<IDriver>(`Driver/${driverId}`);

export const getMyDriverProfile = () =>
  configWithUserToken.get<IDriver>("Driver/me");

export const registerDriverUser = (data: IRegisterDriver) =>
  configWithUserToken.post(`Auth/RegisterDriverUser${restaurantQuery()}`, data);

export const updateDriver = (driverId: string, data: IUpdateDriver) =>
  configWithUserToken.put(`Driver/${driverId}/update-user`, data);

export const deleteDriver = (driverId: string) =>
  configWithUserToken.delete(`Driver/${driverId}/remove-user`);

export const assignDriverToOrder = (driverId: string, orderId: string) =>
  configWithUserToken.post(`Driver/${driverId}/assign/${orderId}`);

export const updateDriverStatus = (driverId: string, status: string) =>
  configWithUserToken.patch(`Driver/${driverId}/status/${status}`);

export const getDriverDeliveries = (driverId: string, pageIndex = 0, pageSize = 20) =>
  configWithUserToken.get<IDriverDelivery[]>(
    `Driver/${driverId}/deliveries?pageIndex=${pageIndex}&pageSize=${pageSize}`
  );

export const getDriverActiveOrders = (driverId: string) =>
  configWithUserToken.get<IDriverActiveOrder[]>(`Driver/${driverId}/active-orders`);

export const updateDeliveryStatus = (deliveryId: string, deliveryStatus: DeliveryStatusValue) =>
  configWithUserToken.patch(`Driver/delivery/${deliveryId}/status`, { deliveryStatus });

export const updateDriverLocation = (driverId: string, latitude: number, longitude: number) =>
  configWithUserToken.put(`Driver/${driverId}/location`, { latitude, longitude });
